import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "simple-resource-management" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "header-main" }
const _hoisted_4 = { class: "header-left" }
const _hoisted_5 = { class: "view-toggle" }
const _hoisted_6 = {
  key: 0,
  class: "header-actions"
}
const _hoisted_7 = { class: "search-box" }
const _hoisted_8 = { class: "resource-actions" }
const _hoisted_9 = {
  key: 0,
  class: "table-container"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { key: 1 }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "pagination-container" }
const _hoisted_26 = {
  key: 1,
  class: "dashboard-container"
}
const _hoisted_27 = { class: "dashboard-layout" }
const _hoisted_28 = { class: "dashboard-left" }
const _hoisted_29 = { class: "dashboard-card interview-calendar" }
const _hoisted_30 = { class: "card-body" }
const _hoisted_31 = { class: "calendar-wrapper" }
const _hoisted_32 = { class: "calendar-container" }
const _hoisted_33 = { class: "calendar-title" }
const _hoisted_34 = { class: "calendar-body" }
const _hoisted_35 = { class: "day-number" }
const _hoisted_36 = {
  key: 0,
  class: "interview-marker"
}
const _hoisted_37 = { class: "dashboard-right" }
const _hoisted_38 = { class: "dashboard-row" }
const _hoisted_39 = { class: "dashboard-card stat-card" }
const _hoisted_40 = { class: "card-body" }
const _hoisted_41 = { class: "stat-value-large" }
const _hoisted_42 = { class: "icon-container" }
const _hoisted_43 = { class: "value" }
const _hoisted_44 = { class: "dashboard-card stat-card" }
const _hoisted_45 = { class: "card-body" }
const _hoisted_46 = { class: "stat-value-large" }
const _hoisted_47 = { class: "icon-container" }
const _hoisted_48 = { class: "value" }
const _hoisted_49 = { class: "dashboard-card stat-card" }
const _hoisted_50 = { class: "card-body" }
const _hoisted_51 = { class: "stat-value-large" }
const _hoisted_52 = { class: "icon-container" }
const _hoisted_53 = { class: "value" }
const _hoisted_54 = { class: "dashboard-card application-stats" }
const _hoisted_55 = { class: "card-body" }
const _hoisted_56 = { class: "stats-container" }
const _hoisted_57 = { class: "stat-label" }
const _hoisted_58 = { class: "stat-bar-container" }
const _hoisted_59 = { class: "stat-value" }
const _hoisted_60 = { class: "dialog-footer" }

import { ref, reactive, onMounted, onBeforeUnmount, computed, watch } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage, ElMessageBox, FormInstance } from 'element-plus';
import { 
  Grid, 
  DataBoard, 
  Search, 
  Plus,
  Lock,
  Link,
  ArrowDown,
  Calendar,
  Flag,
  Document,
  Timer
} from '@element-plus/icons-vue';
import jobApplicationService, { JobApplication, QueryParams, PageResult } from '@/services/jobApplicationService';
import api from '@/services/api';


export default /*@__PURE__*/_defineComponent({
  __name: 'SimpleResourceManagement',
  setup(__props) {

const router = useRouter();
const currentView = ref('list');
const searchText = ref('');
const currentPage = ref(1);
const pageSize = ref(10);
const total = ref(0);
const loading = ref(false);
const tableData = ref<JobApplication[]>([]);
const dialogVisible = ref(false);
const isEdit = ref(false);
const submitting = ref(false);
const formRef = ref<FormInstance>();

// 表单数据
const form = reactive<JobApplication>({
  companyName: '',
  city: '',
  websiteUrl: '',
  positionName: '',
  applicationStatus: '待投递',
  interviewTime: new Date().toISOString().slice(0, 16) + ':00',
  salary: '',
  applicationDate: new Date().toISOString().slice(0, 10),
  remarks: ''
});

// 表单验证规则
const rules = {
  companyName: [
    { required: true, message: '请输入公司名称', trigger: 'blur' }
  ],
  positionName: [
    { required: true, message: '请输入岗位名称', trigger: 'blur' }
  ],
  applicationStatus: [
    { required: true, message: '请选择投递进度', trigger: 'change' }
  ]
};

// 仪表盘数据
const applicationStats = ref<Record<string, number>>({});
const loadingStats = ref(false);
const countdownDays = ref('00');
const countdownHours = ref('00');
const countdownMinutes = ref('00');
const earliestApplicationDate = ref('');
const nextInterviewDate = ref<Date | null>(null);
const countdownInterval = ref<number | null>(null);
const interviewDates = ref<Set<string>>(new Set());

// 返回旧版资源管理页面
const returnToOldVersion = () => {
  router.push('/resources/management');
};

// 页面加载时获取数据
onMounted(() => {
  loadData();
  document.addEventListener('click', handleDocumentClick);
  
  // 如果初始视图是仪表盘，则加载仪表盘数据
  if (currentView.value === 'dashboard') {
    loadDashboardData();
  }
});

// 加载数据
const loadData = async () => {
  loading.value = true;
  try {
    const params: QueryParams = {
      page: currentPage.value, // 不再减1，直接使用当前页码，因为jobApplicationService会确保page>=1
      size: pageSize.value
    };
    
    if (searchText.value) {
      params.keyword = searchText.value;
    }
    
    const result = await jobApplicationService.getList(params);
    tableData.value = result.content;
    total.value = result.totalElements;
  } catch (error: any) {
    ElMessage.error(`加载数据失败: ${error.message}`);
  } finally {
    loading.value = false;
  }
};

// 处理搜索
const handleSearch = () => {
  currentPage.value = 1;
  loadData();
};

// 打开添加对话框
const openAddDialog = () => {
  isEdit.value = false;
  dialogVisible.value = true;
};

// 处理编辑
const handleEdit = (row: JobApplication) => {
  isEdit.value = true;
  Object.assign(form, row);
  dialogVisible.value = true;
};

// 处理删除
const handleDelete = (row: JobApplication) => {
  if (!row.id) return;
  
  ElMessageBox.confirm(
    `确定要删除 ${row.companyName} 的记录吗？`,
    '删除确认',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }
  ).then(async () => {
    try {
      await jobApplicationService.delete(row.id as number);
      ElMessage.success('删除成功');
      loadData();
    } catch (error: any) {
      ElMessage.error(`删除失败: ${error.message}`);
    }
  }).catch(() => {
    // 取消删除，不做处理
  });
};

// 提交表单
const submitForm = async () => {
  if (!formRef.value) return;
  
  await formRef.value.validate(async (valid) => {
    if (valid) {
      submitting.value = true;
      try {
        if (isEdit.value && form.id) {
          // 获取原始数据
          const originalData = tableData.value.find(item => item.id === form.id);
          if (originalData) {
            // 创建一个只包含修改字段的对象
            const changedData: Partial<JobApplication> = {};
            
            // 遍历表单字段，比较是否有变化
            Object.keys(form).forEach(key => {
              const typedKey = key as keyof JobApplication;
              // 如果字段值发生了变化，则添加到更新对象中
              if (form[typedKey] !== originalData[typedKey]) {
                changedData[typedKey] = form[typedKey];
              }
            });
            
            // 只有当有字段变化时才发送更新请求
            if (Object.keys(changedData).length > 0) {
              await jobApplicationService.update(form.id, changedData);
              ElMessage.success('更新成功');
            } else {
              ElMessage.info('没有字段发生变化');
            }
          } else {
            // 如果找不到原始数据，则发送完整表单
            await jobApplicationService.update(form.id, form);
            ElMessage.success('更新成功');
          }
        } else {
          await jobApplicationService.create(form);
          ElMessage.success('添加成功');
        }
        dialogVisible.value = false;
        loadData();
      } catch (error: any) {
        ElMessage.error(`提交失败: ${error.message}`);
      } finally {
        submitting.value = false;
      }
    }
  });
};

// 重置表单
const resetForm = () => {
  if (formRef.value) {
    formRef.value.resetFields();
  }
  
  Object.assign(form, {
    companyName: '',
    city: '',
    websiteUrl: '',
    positionName: '',
    applicationStatus: '待投递',
    interviewTime: new Date().toISOString().slice(0, 16) + ':00',
    salary: '',
    applicationDate: new Date().toISOString().slice(0, 10),
    remarks: ''
  });
};

// 获取状态标签类型
const getStatusType = (status: string) => {
  const statusMap: Record<string, string> = {
    '待投递': 'info',
    '已投递': 'info',
    '已被拒': 'danger',
    '一面': 'warning',
    '二面': 'success',
    '三面': 'success',
    '主管面': 'primary',
    'HR面': 'primary',
    '已通过': 'success',
    '已拒绝': 'danger',
    '已发offer': 'success',
    '放弃offer': 'warning'
  };
  
  return statusMap[status] || 'info';
};

// 处理分页大小变化
const handleSizeChange = (size: number) => {
  pageSize.value = size;
  loadData();
};

// 处理页码变化
const handlePageChange = (page: number) => {
  currentPage.value = page;
  loadData();
};

// 处理行点击
const handleRowClick = (row: JobApplication) => {
  // 如果正在编辑某个单元格，则不处理行点击事件
  if (editingCell.value) return;
  
  // 可以添加详细信息查看功能
  console.log('行点击', row);
};

// 格式化日期时间
const formatDateTime = (dateTimeStr: string) => {
  if (!dateTimeStr) return '';
  
  // 处理带T的ISO格式日期
  const dateTime = dateTimeStr.replace('T', ' ').substring(0, 16);
  return dateTime;
};

// 格式化日期
const formatDate = (dateStr: string | undefined) => {
  if (!dateStr) return '';
  return dateStr;
};

// 计算已投时间（从申请时间到现在）
const calculateAppliedTime = (applicationTime: string | undefined) => {
  if (!applicationTime) return '计算中...';
  
  try {
    const applyDate = new Date(applicationTime);
    const now = new Date();
    
    const diffMs = now.getTime() - applyDate.getTime();
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    
    if (diffDays > 0) {
      return `${diffDays}天`;
    } else {
      const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
      if (diffHours > 0) {
        return `${diffHours}小时`;
      } else {
        const diffMinutes = Math.floor(diffMs / (1000 * 60));
        return `${diffMinutes}分钟`;
      }
    }
  } catch (error) {
    return '计算中...';
  }
};

// 添加编辑相关的状态
const editingCell = ref<{row: number, property: string} | null>(null);
const editingValue = ref('');

// 处理单元格单击
const handleCellClick = (row: JobApplication, column: any, cell: HTMLElement, event: Event) => {
  // 阻止事件冒泡
  event.stopPropagation();
  
  // 忽略不可编辑的列
  const nonEditableColumns = ['操作', '网址地址', '已投时间'];
  if (nonEditableColumns.includes(column.label)) return;
  
  const rowIndex = tableData.value.findIndex(item => item.id === row.id);
  if (rowIndex === -1) return;
  
  // 如果已经在编辑其他单元格，先保存
  if (editingCell.value) {
    saveEdit();
  }
  
  editingCell.value = {
    row: rowIndex,
    property: column.property
  };
  
  // 设置当前编辑值
  editingValue.value = row[column.property as keyof JobApplication] as string || '';
};

// 保存编辑
const saveEdit = async () => {
  if (!editingCell.value) return;
  
  const { row, property } = editingCell.value;
  const currentRow = tableData.value[row];
  
  // 如果值没变，则不更新
  if (currentRow[property as keyof JobApplication] === editingValue.value) {
    editingCell.value = null;
    return;
  }
  
  // 只发送需要更新的字段
  const updateData = {
    [property]: editingValue.value
  };
  
  try {
    if (currentRow.id) {
      await jobApplicationService.update(currentRow.id, updateData);
      ElMessage.success('更新成功');
      
      // 更新本地数据
      tableData.value[row] = { 
        ...currentRow,
        [property]: editingValue.value 
      };
    }
  } catch (error: any) {
    ElMessage.error(`更新失败: ${error.message}`);
  } finally {
    editingCell.value = null;
  }
};

// 取消编辑
const cancelEdit = () => {
  editingCell.value = null;
};

// 监听全局点击事件关闭编辑框
const handleDocumentClick = (event: MouseEvent) => {
  if (editingCell.value) {
    const editingElement = document.querySelector('.cell-editing');
    // 如果点击的不是正在编辑的单元格，也不是其子元素，则保存编辑
    if (editingElement && !editingElement.contains(event.target as Node)) {
      // 检查点击的元素是否是el-select或el-date-picker的下拉菜单
      const isDropdownElement = (
        (event.target as Element)?.closest('.el-select-dropdown') || 
        (event.target as Element)?.closest('.el-picker-panel')
      );
      
      // 如果不是下拉菜单元素，则保存编辑
      if (!isDropdownElement) {
        saveEdit();
      }
    }
  }
};

// 在组件销毁时移除事件监听
onBeforeUnmount(() => {
  document.removeEventListener('click', handleDocumentClick);
  if (countdownInterval.value) {
    clearInterval(countdownInterval.value);
  }
});

// 判断单元格是否处于编辑状态
const isCellEditing = (row: number, property: string) => {
  return editingCell.value && editingCell.value.row === row && editingCell.value.property === property;
};

// 处理编辑时的键盘事件
const handleEditKeydown = (event: KeyboardEvent) => {
  if (event.key === 'Enter') {
    event.preventDefault();
    saveEdit();
  } else if (event.key === 'Escape') {
    event.preventDefault();
    cancelEdit();
  }
};

// 加载仪表盘数据
const loadDashboardData = async () => {
  loadingStats.value = true;
  try {
    // 获取投递统计数据
    applicationStats.value = await jobApplicationService.getStats();
    
    // 获取所有申请记录，用于计算最早投递日期和下一次面试
    const allApplicationsResponse = await jobApplicationService.getList({ page: 1, size: 1000 });
    const allApplications = allApplicationsResponse.content;
    
    // 计算最早投递日期
    if (allApplications.length > 0) {
      const dates = allApplications
        .filter(app => app.applicationDate)
        .map(app => new Date(app.applicationDate as string).getTime());
      
      if (dates.length > 0) {
        const earliestDate = new Date(Math.min(...dates));
        earliestApplicationDate.value = earliestDate.toISOString().split('T')[0];
      }
    }
    
    // 查找下一次面试
    const now = new Date();
    const upcomingInterviews = allApplications
      .filter(app => app.interviewTime && new Date(app.interviewTime) > now)
      .sort((a, b) => {
        const dateA = new Date(a.interviewTime as string);
        const dateB = new Date(b.interviewTime as string);
        return dateA.getTime() - dateB.getTime();
      });
    
    if (upcomingInterviews.length > 0) {
      nextInterviewDate.value = new Date(upcomingInterviews[0].interviewTime as string);
      startCountdown();
    } else {
      countdownDays.value = '00';
      countdownHours.value = '00';
      countdownMinutes.value = '00';
    }
    
    // 更新日历中的面试标记
    updateCalendarInterviews(allApplications);
    
  } catch (error: any) {
    ElMessage.error(`加载仪表盘数据失败: ${error.message}`);
  } finally {
    loadingStats.value = false;
  }
};

// 更新日历中的面试标记
const updateCalendarInterviews = (applications: JobApplication[]) => {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth();
  
  // 清空之前的面试日期
  interviewDates.value.clear();
  
  // 找出当月的所有面试
  applications.forEach(app => {
    if (!app.interviewTime) return;
    
    const interviewDate = new Date(app.interviewTime);
    if (interviewDate.getFullYear() === currentYear && 
        interviewDate.getMonth() === currentMonth) {
      // 存储面试日期，格式为 YYYY-MM-DD
      const dateKey = interviewDate.toISOString().split('T')[0];
      interviewDates.value.add(dateKey);
    }
  });
};

// 开始倒计时
const startCountdown = () => {
  // 清除之前的定时器
  if (countdownInterval.value) {
    clearInterval(countdownInterval.value);
  }
  
  // 设置新的定时器
  countdownInterval.value = window.setInterval(() => {
    if (!nextInterviewDate.value) return;
    
    const now = new Date();
    const diff = nextInterviewDate.value.getTime() - now.getTime();
    
    if (diff <= 0) {
      // 面试时间已到
      countdownDays.value = '00';
      countdownHours.value = '00';
      countdownMinutes.value = '00';
      clearInterval(countdownInterval.value as number);
      return;
    }
    
    // 计算天、时、分
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    
    countdownDays.value = days.toString().padStart(2, '0');
    countdownHours.value = hours.toString().padStart(2, '0');
    countdownMinutes.value = minutes.toString().padStart(2, '0');
  }, 1000);
};

// 计算统计条的宽度
const getStatBarWidth = (count: number) => {
  const total = Object.values(applicationStats.value).reduce((sum, val) => sum + val, 0);
  if (total === 0) return '0%';
  
  // 如果count为undefined，返回0%
  if (count === undefined) return '0%';
  
  return `${(count / total) * 100}%`;
};

// 生成日历数据
const calendarData = computed(() => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  
  // 获取当月第一天
  const firstDay = new Date(year, month, 1);
  // 获取当月最后一天
  const lastDay = new Date(year, month + 1, 0);
  
  // 当月第一天是星期几（0-6，0是星期日）
  let firstDayOfWeek = firstDay.getDay();
  // 调整为星期一为一周的第一天
  firstDayOfWeek = firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1;
  
  // 日历数据
  const days = [];
  
  // 添加上个月的日期
  const prevMonthLastDay = new Date(year, month, 0).getDate();
  for (let i = 0; i < firstDayOfWeek; i++) {
    days.push({
      date: prevMonthLastDay - firstDayOfWeek + i + 1,
      isCurrentMonth: false,
      hasInterview: false
    });
  }
  
  // 添加当月的日期
  for (let i = 1; i <= lastDay.getDate(); i++) {
    // 检查这一天是否有面试
    const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(i).padStart(2, '0')}`;
    const hasInterview = interviewDates.value.has(dateStr);
    
    days.push({
      date: i,
      isCurrentMonth: true,
      hasInterview: hasInterview,
      isToday: i === now.getDate()
    });
  }
  
  // 添加下个月的日期
  const remainingDays = 42 - days.length; // 6行7列 = 42
  for (let i = 1; i <= remainingDays; i++) {
    days.push({
      date: i,
      isCurrentMonth: false,
      hasInterview: false
    });
  }
  
  return days;
});

// 计算投递数量
const getTotalApplications = () => {
  return Object.values(applicationStats.value).reduce((sum, count) => sum + count, 0);
};

// 计算投递天数
const calculateApplicationDays = () => {
  if (!earliestApplicationDate.value) {
    return 0;
  }
  
  const now = new Date();
  const startDate = new Date(earliestApplicationDate.value);
  const diffTime = Math.abs(now.getTime() - startDate.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays || 0;
};

// 处理视图切换
const handleViewChange = (view: string) => {
  if (view === 'dashboard') {
    loadDashboardData();
  } else if (view === 'list') {
    loadData();
  }
};

// 添加排序投递状态的逻辑，按照指定顺序：待投递，已投递，已被拒，一面，二面，主管面，已发offer，放弃offer
const statusOrder = ['待投递', '已投递', '已被拒', '一面', '二面', '主管面', '已发offer', '放弃offer'];

// 排序后的投递状态
const sortedApplicationStatuses = computed(() => {
  // 确保所有预定义状态都存在，即使数量为0
  const result = [...statusOrder];
  
  // 添加可能存在但不在预定义列表中的其他状态
  const otherStatuses = Object.keys(applicationStats.value).filter(
    status => !statusOrder.includes(status)
  );
  
  if (otherStatuses.length > 0) {
    // 按字母顺序排序其他状态
    otherStatuses.sort((a, b) => a.localeCompare(b));
    result.push(...otherStatuses);
  }
  
  return result;
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[23] || (_cache[23] = _createElementVNode("h1", { class: "page-title" }, "资源管理", -1)),
          _cache[24] || (_cache[24] = _createElementVNode("p", { class: "page-description" }, "管理您的求职相关资源", -1)),
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            class: "old-version-btn",
            onClick: returnToOldVersion
          }, {
            default: _withCtx(() => _cache[22] || (_cache[22] = [
              _createTextVNode(" 返回旧版 ")
            ])),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_radio_group, {
            modelValue: currentView.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentView).value = $event)),
            size: "large",
            class: "custom-radio-group",
            onChange: handleViewChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_button, {
                label: "list",
                class: "rounded-button"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Grid))
                    ]),
                    _: 1
                  }),
                  _cache[25] || (_cache[25] = _createTextVNode(" 列表视图 "))
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio_button, {
                label: "dashboard",
                class: "rounded-button"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DataBoard))
                    ]),
                    _: 1
                  }),
                  _cache[26] || (_cache[26] = _createTextVNode(" 仪表盘 "))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      (currentView.value === 'list')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_input, {
                modelValue: searchText.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchText).value = $event)),
                placeholder: "搜索公司...",
                clearable: "",
                class: "rounded-search",
                onClear: loadData,
                onKeyup: _withKeys(handleSearch, ["enter"]),
                size: "default"
              }, {
                prefix: _withCtx(() => [
                  _createVNode(_component_el_icon, { class: "search-icon" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Search))
                    ]),
                    _: 1
                  })
                ]),
                suffix: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    circle: "",
                    plain: "",
                    class: "search-action-button",
                    onClick: handleSearch,
                    title: "搜索"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Search))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: openAddDialog,
                round: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Plus))
                    ]),
                    _: 1
                  }),
                  _cache[27] || (_cache[27] = _createTextVNode(" 添加记录 "))
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (currentView.value === 'list')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: tableData.value,
            style: {"width":"100%"},
            "row-key": "id",
            border: "",
            "header-cell-style": { background: '#f5f7fa', color: '#606266' },
            class: "rounded-table",
            onRowClick: handleRowClick
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "selection",
                width: "55",
                align: "center",
                selectable: () => false,
                "class-name": "selection-column"
              }),
              _createVNode(_component_el_table_column, {
                label: "公司名称",
                prop: "companyName",
                "min-width": "180"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["editable-cell", {'cell-editing': isCellEditing(tableData.value.indexOf(scope.row), 'companyName')}]),
                    onClick: _withModifiers(($event: any) => (handleCellClick(scope.row, {property: 'companyName', label: '公司名称'}, $event.target, $event)), ["stop"])
                  }, [
                    (isCellEditing(tableData.value.indexOf(scope.row), 'companyName'))
                      ? (_openBlock(), _createBlock(_component_el_input, {
                          key: 0,
                          modelValue: editingValue.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editingValue).value = $event)),
                          size: "small",
                          onKeydown: handleEditKeydown,
                          ref: "editInput",
                          autofocus: "",
                          class: "seamless-input"
                        }, null, 8, ["modelValue"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(scope.row.companyName), 1))
                  ], 10, _hoisted_10)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "城市",
                prop: "city",
                width: "120"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["editable-cell", {'cell-editing': isCellEditing(tableData.value.indexOf(scope.row), 'city')}]),
                    onClick: _withModifiers(($event: any) => (handleCellClick(scope.row, {property: 'city', label: '城市'}, $event.target, $event)), ["stop"])
                  }, [
                    (isCellEditing(tableData.value.indexOf(scope.row), 'city'))
                      ? (_openBlock(), _createBlock(_component_el_input, {
                          key: 0,
                          modelValue: editingValue.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((editingValue).value = $event)),
                          size: "small",
                          onKeydown: handleEditKeydown,
                          autofocus: "",
                          class: "seamless-input"
                        }, null, 8, ["modelValue"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(scope.row.city), 1))
                  ], 10, _hoisted_12)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "网址地址",
                "min-width": "150"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.websiteUrl)
                    ? (_openBlock(), _createBlock(_component_el_link, {
                        key: 0,
                        type: "primary",
                        href: scope.row.websiteUrl,
                        target: "_blank",
                        onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Link))
                            ]),
                            _: 1
                          }),
                          _cache[28] || (_cache[28] = _createTextVNode(" 访问网站 "))
                        ]),
                        _: 2
                      }, 1032, ["href"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "岗位名称",
                prop: "positionName",
                "min-width": "150"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["editable-cell", {'cell-editing': isCellEditing(tableData.value.indexOf(scope.row), 'positionName')}]),
                    onClick: _withModifiers(($event: any) => (handleCellClick(scope.row, {property: 'positionName', label: '岗位名称'}, $event.target, $event)), ["stop"])
                  }, [
                    (isCellEditing(tableData.value.indexOf(scope.row), 'positionName'))
                      ? (_openBlock(), _createBlock(_component_el_input, {
                          key: 0,
                          modelValue: editingValue.value,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((editingValue).value = $event)),
                          size: "small",
                          onKeydown: handleEditKeydown,
                          autofocus: "",
                          class: "seamless-input"
                        }, null, 8, ["modelValue"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(scope.row.positionName), 1))
                  ], 10, _hoisted_14)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "投递进度",
                width: "120"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["editable-cell", {'cell-editing': isCellEditing(tableData.value.indexOf(scope.row), 'applicationStatus')}]),
                    onClick: _withModifiers(($event: any) => (handleCellClick(scope.row, {property: 'applicationStatus', label: '投递进度'}, $event.target, $event)), ["stop"])
                  }, [
                    (isCellEditing(tableData.value.indexOf(scope.row), 'applicationStatus'))
                      ? (_openBlock(), _createBlock(_component_el_select, {
                          key: 0,
                          modelValue: editingValue.value,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((editingValue).value = $event)),
                          size: "small",
                          placeholder: "请选择",
                          onChange: saveEdit,
                          style: {"width":"100%"},
                          autofocus: "",
                          class: "seamless-input"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "待投递",
                              value: "待投递"
                            }),
                            _createVNode(_component_el_option, {
                              label: "已投递",
                              value: "已投递"
                            }),
                            _createVNode(_component_el_option, {
                              label: "已被拒",
                              value: "已被拒"
                            }),
                            _createVNode(_component_el_option, {
                              label: "一面",
                              value: "一面"
                            }),
                            _createVNode(_component_el_option, {
                              label: "二面",
                              value: "二面"
                            }),
                            _createVNode(_component_el_option, {
                              label: "主管面",
                              value: "主管面"
                            }),
                            _createVNode(_component_el_option, {
                              label: "已发offer",
                              value: "已发offer"
                            }),
                            _createVNode(_component_el_option, {
                              label: "放弃offer",
                              value: "放弃offer"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (scope.row.applicationStatus)
                            ? (_openBlock(), _createBlock(_component_el_tag, {
                                key: 0,
                                type: getStatusType(scope.row.applicationStatus),
                                size: "small",
                                effect: "light",
                                class: "status-tag"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(scope.row.applicationStatus), 1)
                                ]),
                                _: 2
                              }, 1032, ["type"]))
                            : _createCommentVNode("", true)
                        ], 64))
                  ], 10, _hoisted_16)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "面试时间",
                width: "180"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["editable-cell", {'cell-editing': isCellEditing(tableData.value.indexOf(scope.row), 'interviewTime')}]),
                    onClick: _withModifiers(($event: any) => (handleCellClick(scope.row, {property: 'interviewTime', label: '面试时间'}, $event.target, $event)), ["stop"])
                  }, [
                    (isCellEditing(tableData.value.indexOf(scope.row), 'interviewTime'))
                      ? (_openBlock(), _createBlock(_component_el_date_picker, {
                          key: 0,
                          modelValue: editingValue.value,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((editingValue).value = $event)),
                          size: "small",
                          type: "datetime",
                          placeholder: "选择日期时间",
                          format: "YYYY-MM-DD HH:mm",
                          "value-format": "YYYY-MM-DDTHH:mm:00",
                          style: {"width":"100%"},
                          onChange: saveEdit,
                          class: "seamless-input"
                        }, null, 8, ["modelValue"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(formatDateTime(scope.row.interviewTime)), 1))
                  ], 10, _hoisted_17)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "岗位待遇",
                width: "120"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["editable-cell", {'cell-editing': isCellEditing(tableData.value.indexOf(scope.row), 'salary')}]),
                    onClick: _withModifiers(($event: any) => (handleCellClick(scope.row, {property: 'salary', label: '岗位待遇'}, $event.target, $event)), ["stop"])
                  }, [
                    (isCellEditing(tableData.value.indexOf(scope.row), 'salary'))
                      ? (_openBlock(), _createBlock(_component_el_input, {
                          key: 0,
                          modelValue: editingValue.value,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((editingValue).value = $event)),
                          size: "small",
                          onKeydown: handleEditKeydown,
                          autofocus: "",
                          class: "seamless-input"
                        }, null, 8, ["modelValue"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(scope.row.salary), 1))
                  ], 10, _hoisted_19)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "投递日期",
                width: "120"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["editable-cell", {'cell-editing': isCellEditing(tableData.value.indexOf(scope.row), 'applicationDate')}]),
                    onClick: _withModifiers(($event: any) => (handleCellClick(scope.row, {property: 'applicationDate', label: '投递日期'}, $event.target, $event)), ["stop"])
                  }, [
                    (isCellEditing(tableData.value.indexOf(scope.row), 'applicationDate'))
                      ? (_openBlock(), _createBlock(_component_el_date_picker, {
                          key: 0,
                          modelValue: editingValue.value,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((editingValue).value = $event)),
                          size: "small",
                          type: "date",
                          placeholder: "选择日期",
                          format: "YYYY-MM-DD",
                          "value-format": "YYYY-MM-DD",
                          style: {"width":"100%"},
                          onChange: saveEdit,
                          class: "seamless-input"
                        }, null, 8, ["modelValue"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(formatDate(scope.row.applicationDate)), 1))
                  ], 10, _hoisted_21)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "已投时间",
                width: "120"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(calculateAppliedTime(scope.row.applicationTime)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "备注说明",
                prop: "remarks",
                "min-width": "150"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["editable-cell", {'cell-editing': isCellEditing(tableData.value.indexOf(scope.row), 'remarks')}]),
                    onClick: _withModifiers(($event: any) => (handleCellClick(scope.row, {property: 'remarks', label: '备注说明'}, $event.target, $event)), ["stop"])
                  }, [
                    (isCellEditing(tableData.value.indexOf(scope.row), 'remarks'))
                      ? (_openBlock(), _createBlock(_component_el_input, {
                          key: 0,
                          modelValue: editingValue.value,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((editingValue).value = $event)),
                          size: "small",
                          onKeydown: handleEditKeydown,
                          autofocus: "",
                          class: "seamless-input"
                        }, null, 8, ["modelValue"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(scope.row.remarks), 1))
                  ], 10, _hoisted_23)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "操作",
                width: "90",
                fixed: "right"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_button, {
                    type: "danger",
                    size: "small",
                    text: "",
                    onClick: _withModifiers(($event: any) => (handleDelete(scope.row)), ["stop"])
                  }, {
                    default: _withCtx(() => _cache[29] || (_cache[29] = [
                      _createTextVNode(" 删除 ")
                    ])),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, loading.value]
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_el_pagination, {
              layout: "total, sizes, prev, pager, next",
              total: total.value,
              "page-sizes": [10, 20, 30, 50],
              "current-page": currentPage.value,
              "page-size": pageSize.value,
              onSizeChange: handleSizeChange,
              onCurrentChange: handlePageChange
            }, null, 8, ["total", "current-page", "page-size"])
          ])
        ]))
      : (currentView.value === 'dashboard')
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _cache[32] || (_cache[32] = _createElementVNode("div", { class: "card-header" }, [
                    _createElementVNode("h3", null, "面试时间表")
                  ], -1)),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("span", null, _toDisplayString(new Date().getFullYear()) + "年" + _toDisplayString(new Date().getMonth() + 1) + "月", 1)
                        ]),
                        _cache[31] || (_cache[31] = _createElementVNode("div", { class: "calendar-header" }, [
                          _createElementVNode("div", null, "周一"),
                          _createElementVNode("div", null, "周二"),
                          _createElementVNode("div", null, "周三"),
                          _createElementVNode("div", null, "周四"),
                          _createElementVNode("div", null, "周五"),
                          _createElementVNode("div", null, "周六"),
                          _createElementVNode("div", null, "周日")
                        ], -1)),
                        _createElementVNode("div", _hoisted_34, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calendarData.value, (day, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: _normalizeClass(["calendar-day", {
                        'other-month': !day.isCurrentMonth,
                        'today': day.isToday,
                        'has-interview': day.hasInterview
                      }])
                            }, [
                              _createElementVNode("span", _hoisted_35, _toDisplayString(day.date), 1),
                              (day.hasInterview)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_36, _cache[30] || (_cache[30] = [
                                    _createElementVNode("span", null, "面试", -1)
                                  ])))
                                : _createCommentVNode("", true)
                            ], 2))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _cache[33] || (_cache[33] = _createElementVNode("div", { class: "card-header" }, [
                      _createElementVNode("h3", null, "开始日期")
                    ], -1)),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Calendar))
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_43, _toDisplayString(earliestApplicationDate.value || '暂无数据'), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _cache[34] || (_cache[34] = _createElementVNode("div", { class: "card-header" }, [
                      _createElementVNode("h3", null, "投递数量")
                    ], -1)),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Document))
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_48, _toDisplayString(getTotalApplications()), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _cache[35] || (_cache[35] = _createElementVNode("div", { class: "card-header" }, [
                      _createElementVNode("h3", null, "投递天数")
                    ], -1)),
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Timer))
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_53, _toDisplayString(calculateApplicationDays()), 1)
                      ])
                    ])
                  ])
                ]),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_54, [
                  _cache[36] || (_cache[36] = _createElementVNode("div", { class: "card-header" }, [
                    _createElementVNode("h3", null, "投递状态统计")
                  ], -1)),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedApplicationStatuses.value, (status) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: status,
                          class: "stat-item"
                        }, [
                          _createElementVNode("div", _hoisted_57, _toDisplayString(status), 1),
                          _createElementVNode("div", _hoisted_58, [
                            _createElementVNode("div", {
                              class: "stat-bar",
                              style: _normalizeStyle({ width: getStatBarWidth(applicationStats.value[status]) })
                            }, null, 4),
                            _createElementVNode("div", _hoisted_59, _toDisplayString(applicationStats.value[status] || 0), 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])), [
                  [_directive_loading, loadingStats.value]
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((dialogVisible).value = $event)),
      title: isEdit.value ? '编辑记录' : '添加记录',
      width: "600px",
      "close-on-click-modal": false,
      onClosed: resetForm
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_60, [
          _createVNode(_component_el_button, {
            onClick: _cache[20] || (_cache[20] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => _cache[37] || (_cache[37] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submitForm,
            loading: submitting.value
          }, {
            default: _withCtx(() => _cache[38] || (_cache[38] = [
              _createTextVNode("确认")
            ])),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          rules: rules,
          "label-width": "100px",
          "label-position": "right"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "公司名称",
              prop: "companyName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.companyName,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.companyName) = $event)),
                  placeholder: "请输入公司名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "城市",
              prop: "city"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.city,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.city) = $event)),
                  placeholder: "请输入城市"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "网址地址",
              prop: "websiteUrl"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.websiteUrl,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.websiteUrl) = $event)),
                  placeholder: "请输入网址地址"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "岗位名称",
              prop: "positionName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.positionName,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.positionName) = $event)),
                  placeholder: "请输入岗位名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "投递进度",
              prop: "applicationStatus"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: form.applicationStatus,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.applicationStatus) = $event)),
                  placeholder: "请选择投递进度",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "待投递",
                      value: "待投递"
                    }),
                    _createVNode(_component_el_option, {
                      label: "已投递",
                      value: "已投递"
                    }),
                    _createVNode(_component_el_option, {
                      label: "已被拒",
                      value: "已被拒"
                    }),
                    _createVNode(_component_el_option, {
                      label: "一面",
                      value: "一面"
                    }),
                    _createVNode(_component_el_option, {
                      label: "二面",
                      value: "二面"
                    }),
                    _createVNode(_component_el_option, {
                      label: "主管面",
                      value: "主管面"
                    }),
                    _createVNode(_component_el_option, {
                      label: "已发offer",
                      value: "已发offer"
                    }),
                    _createVNode(_component_el_option, {
                      label: "放弃offer",
                      value: "放弃offer"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "面试时间",
              prop: "interviewTime"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: form.interviewTime,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.interviewTime) = $event)),
                  type: "datetime",
                  placeholder: "请选择面试时间",
                  format: "YYYY-MM-DD HH:mm",
                  "value-format": "YYYY-MM-DDTHH:mm:00",
                  style: {"width":"100%"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "岗位待遇",
              prop: "salary"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.salary,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((form.salary) = $event)),
                  placeholder: "请输入岗位待遇"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "投递日期",
              prop: "applicationDate"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: form.applicationDate,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((form.applicationDate) = $event)),
                  type: "date",
                  placeholder: "请选择投递日期",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  style: {"width":"100%"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "备注说明",
              prop: "remarks"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.remarks,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((form.remarks) = $event)),
                  type: "textarea",
                  rows: "4",
                  placeholder: "请输入备注说明"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})